<button #langBtn type="button" data-dropdown-toggle="language-dropdown"
    class=" inline-flex justify-center p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white">
    <img src="assets/flags/language/{{translateService.languageAsync|async}}.svg" width="19">
</button>
<!-- Dropdown -->
<div #lang
    class="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700"
    id="language-dropdown">
    <ul class="py-1 cursor-pointer" role="none" (click)="close()">
        <li>
            <a (click)="translateService.changeLanguage('en')"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                role="menuitem">
                <div class="inline-flex items-center">
                    <img src="assets/flags/language/en.svg" class="mr-1" width="19">
                    English (US)
                </div>
            </a>
        </li>
        <li>
            <a (click)="translateService.changeLanguage('nl')"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                role="menuitem">
                <div class="inline-flex items-center">
                    <img src="assets/flags/language/nl.svg" class="mr-1" width="19">
                    Nederlands
                </div>
            </a>
        </li>
        <li>
            <a (click)="translateService.changeLanguage('es')"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                role="menuitem">
                <div class="inline-flex items-center">
                    <img src="assets/flags/es.svg" class="mr-1" width="19">
                    Español
                </div>
            </a>
        </li>
        <li>
            <a (click)="translateService.changeLanguage('fr')"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                role="menuitem">
                <div class="inline-flex items-center">
                    <img src="assets/flags/fr.svg" class="mr-1" width="19">
                    Français
                </div>
            </a>
        </li>
        <li>
            <a (click)="translateService.changeLanguage('de')"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                role="menuitem">
                <div class="inline-flex items-center">
                    <img src="assets/flags/de.svg" class="mr-1" width="19">
                    Deutsch
                </div>
            </a>
        </li>
        <li>
            <a (click)="translateService.changeLanguage('da')"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                role="menuitem">
                <div class="inline-flex items-center">
                    <img src="assets/flags/da.svg" class="mr-1" width="19">
                    Dansk
                </div>
            </a>
        </li>
        <li>
            <a (click)="translateService.changeLanguage('sv')"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                role="menuitem">
                <div class="inline-flex items-center">
                    <img src="assets/flags/sv.svg" class="mr-1" width="19">
                    Svesnka
                </div>
            </a>
        </li>
        <li>
            <a (click)="translateService.changeLanguage('it')"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                role="menuitem">
                <div class="inline-flex items-center">
                    <img src="assets/flags/it.svg" class="mr-1" width="19">
                    Italiano
                </div>
            </a>
        </li>
    </ul>
</div>